import { render, staticRenderFns } from "./chatWindowNew.vue?vue&type=template&id=8836373a&scoped=true"
import script from "./chatWindowNew.vue?vue&type=script&lang=js"
export * from "./chatWindowNew.vue?vue&type=script&lang=js"
import style0 from "./chatWindowNew.vue?vue&type=style&index=0&id=8836373a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8836373a",
  null
  
)

export default component.exports